import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { map, catchError } from 'rxjs/operators';
import { domain } from 'src/environments/environment';
import { GlobalProvider } from './global';
import { ToastController } from '@ionic/angular';
import { BaseHelper } from 'src/app/baseHelper';


@Injectable({
  providedIn: 'root',
})
export class BusinessStaffApiService {
  constructor(private http: HttpClient, private g: GlobalProvider, private toastController: ToastController, private b:BaseHelper) {}
  getHeader = () => {
    return {
      headers: new HttpHeaders({
        Authorization: this.g.jws,
      }),
    };
  };

 namespace = 'businessStaff';

 async list(params = {}, businessId:any) {
    const options = { ...this.getHeader(), params };
    const url = `${domain}/${this.namespace}/${businessId}/list`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async get(id:any) {
    const options = { ...this.getHeader() };
    const url = `${domain}/${this.namespace}/${id}/get`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async addStaff(businessId:any, data:any) {
    const url = `${domain}/${this.namespace}/${businessId}/add`;
    return this.http.post(url, data, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async updateStaff(businessId:any, staffId:any, data:any) {
    const url = `${domain}/${this.namespace}/${businessId}/${staffId}/update`;
    return this.http.post(url, data, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  errorHandle(err:any) {
    this.b.loadLoading(false);
    let message = err.error ? err.error.message : err.message;
    if (!message) message = err.error ? err.error : 'unknown error';

    this.b.toast(`${err.status}: ${message}`, 5000, `danger`);
  }
}
